<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('ordine.aggiunte')}}</h5>
        </div>
        <div slot="body">
            {{$t('ordine.seleziona_aggiunte')}}:<br>
            <ul style="max-height:310px; overflow-y:auto;" v-if="this.groups.length">
                <li v-for="group in this.groups" class="mt-3">
                    <b class="text-uppercase">{{group.alias}}</b>
                    <b v-if="group.max_aggiunte || group.aggiunte_gratis">
                        <br/>
                        (<span v-if="group.max_aggiunte">
                            {{$tc('max_scelte',group.max_aggiunte,{n:group.max_aggiunte})}}
                            <span v-if="group.aggiunte_gratis"> - </span>
                        </span>
                        <span v-if="group.aggiunte_gratis">
                            {{$tc('aggiunte_gratis',group.aggiunte_gratis,{n:group.aggiunte_gratis})}}
                        </span>)
                    </b>
                    <span v-for="add in group.processed_adds">
                        <mcw-checkbox @change="handleAddition(group, add)" :checked="isAdditionSelected(add)"
                                      :disabled="!isAdditionSelected(add) && addHasReachedMax(group)">
                            &nbsp; {{add.alias}} ({{getAddPrice(group, add).toFixedGood(2)}} {{locale_currency}})
                        </mcw-checkbox>
                    </span>
                </li>
            </ul>
            <span v-else>
                {{$t('adds_not_availabe_with_config')}}
            </span>
        </div>
        <div slot="footer" class="d-flex flex-fill justify-content-between">
            <button type="button" class="btn btn-default w-auto" @click="$emit('close')">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary w-auto" @click="$emit('close', current_adds)">
                {{$t('btn_salva')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';

    import Modal from '../../partials/Modal';

    export default {
        name: "ModalAdds",
        components: {Modal},
        props: ['adds', 'currentAdds', 'measureId'],
        data() {
            return {
                current_adds: (this.currentAdds || []).map((add) => ({...add}))
            }
        },
        mounted() {
            this.normalizeAllAddPrices();
        },
        computed: {
            groups: function () {
                let groups = this.adds.gruppi;

                groups.forEach((item) => {
                    item.processed_adds = [];

                    const groupMeasure = this.adds.misure_gruppi.find((group) => {
                        return (group.id_misura_tipologia_prodotto === this.measureId && group.id_gruppo_aggiunte === item.id);
                    });

                    if (groupMeasure) {
                        item.max_aggiunte = groupMeasure.max_aggiunte;
                        item.aggiunte_gratis = groupMeasure.aggiunte_gratis;
                    }
                });

                this.adds.ingredienti.forEach((ingredient) => {
                    if (ingredient.mask_locali_esclusi & this.locale.id) return;

                    const groupMeasure = this.adds.misure_gruppi.find((group) => {
                        return (group.id_misura_tipologia_prodotto === this.measureId && group.id_gruppo_aggiunte === ingredient.id_gruppo_aggiunte);
                    });

                    if (groupMeasure) {
                        //Cerco se esiste un'override del prezzo
                        const override = (ingredient.misure_prezzi_override || []).find((obj) => {
                            return (obj.id_misura_tipologia_prodotto === this.measureId);
                        });

                        const configuredPrice = override ? override.prezzo : groupMeasure.variazione_prezzo;
                        let add = Object.assign({}, ingredient, {
                            variazione_prezzo: configuredPrice,
                            variazione_prezzo_originale: configuredPrice,
                            f_override: !!override
                        });

                        groups.forEach((group) => {
                            if (group.id === add.id_gruppo_aggiunte) {
                                add.nome_gruppo_aggiunte = group.nome;
                                group.processed_adds.push(add);
                            }
                        });
                    }
                });

                //sort...
                groups.sort((item1, item2) => {
                    if (item1.alias < item2.alias) {
                        return -1;
                    }

                    if (item1.alias > item2.alias) {
                        return 1;
                    }

                    return 0;
                });

                groups.forEach((item) => {
                    item.processed_adds.sort((item1, item2) => {
                        if (item1.alias < item2.alias) {
                            return -1;
                        }

                        if (item1.alias > item2.alias) {
                            return 1;
                        }

                        return 0;
                    });
                });

                return groups.filter((group) => {
                    return group.processed_adds.length;
                });
            },
            ...mapState('restaurant', {
                locale: state => state.locale
            }),
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        },
        methods: {
            getConfiguredAddPrice: function (add) {
                const override = (add.misure_prezzi_override || []).find((obj) => {
                    return obj.id_misura_tipologia_prodotto === this.measureId;
                });

                if (override) {
                    return override.prezzo;
                }

                const groupMeasure = (this.adds.misure_gruppi || []).find((group) => {
                    return group.id_misura_tipologia_prodotto === this.measureId &&
                        group.id_gruppo_aggiunte === add.id_gruppo_aggiunte;
                });

                if (groupMeasure) {
                    return groupMeasure.variazione_prezzo;
                }

                return add.variazione_prezzo_originale !== undefined && add.variazione_prezzo_originale !== null
                    ? add.variazione_prezzo_originale
                    : add.variazione_prezzo;
            },
            normalizeAllAddPrices: function () {
                this.groups.forEach((group) => {
                    this.normalizeGroupAddPrices(group);
                });
            },
            normalizeGroupAddPrices: function (group) {
                const freeAdds = Number(group.aggiunte_gratis) || 0;
                let normalizedFreeAdds = 0;

                this.current_adds = this.current_adds.map((current_add) => {
                    if (current_add.id_gruppo_aggiunte !== group.id) {
                        return current_add;
                    }

                    const normalizedAdd = {...current_add};
                    normalizedAdd.variazione_prezzo = normalizedFreeAdds < freeAdds
                        ? 0
                        : this.getConfiguredAddPrice(normalizedAdd);
                    normalizedFreeAdds++;

                    return normalizedAdd;
                });
            },
            getAddPrice: function (group, add) {
                const alreadySelectedAdd = this.current_adds.find((current_add) => {
                    return current_add.id_gruppo_aggiunte === group.id && current_add.id === add.id;
                });

                if (alreadySelectedAdd) {
                    return alreadySelectedAdd.variazione_prezzo;
                }

                const groupAdds = this.current_adds.filter((current_add) => {
                    return current_add.id_gruppo_aggiunte === group.id;
                });

                return groupAdds.length < (Number(group.aggiunte_gratis) || 0)
                    ? 0
                    : this.getConfiguredAddPrice(add);
            },
            handleAddition: function (group, add) {
                const index = this.current_adds.findIndex((current_add) => {
                    return current_add.id_gruppo_aggiunte === group.id && current_add.id === add.id;
                });

                //se c'è già l'aggiunta nella lista devo rimuoverla
                if (index >= 0) {
                    this.current_adds.splice(index, 1);
                    this.normalizeGroupAddPrices(group);
                } else if (!this.addHasReachedMax(group)) {
                    const selectedAdd = {...add};
                    selectedAdd.variazione_prezzo = this.getConfiguredAddPrice(selectedAdd);
                    this.current_adds.push(selectedAdd);
                    this.normalizeGroupAddPrices(group);
                }
            },
            addHasReachedMax: function (group) {
                if (group.max_aggiunte) {
                    //Controllo se non ha già raggiunto il massimo
                    const countAdds = this.current_adds.filter((current_add) => {
                        return current_add.id_gruppo_aggiunte === group.id;
                    }).length;

                    if (countAdds >= group.max_aggiunte) {
                        return true;
                    }
                }

                return false;
            },
            isAdditionSelected: function (add) {
                return this.current_adds.findIndex(current_add => current_add.id === add.id) >= 0;
            }

        }
    }
</script>
